<h2 mat-dialog-title>{{'workTask.workflow_action_title' | translate}}</h2>

<mat-dialog-content>
  <div class="pt-2 pb-3">
    <form [formGroup]="workflowForm">
      @if (workflows && workflows.length > 0) {
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'workTask.select_list' | translate}}</mat-label>
          <mat-select formControlName="workflowTemplateId" required>
            <mat-option value=""> - </mat-option>
            @for (workflow of workflows; track workflow) {
              <mat-option [value]="workflow.id">{{workflow.name}}</mat-option>
            }
          </mat-select>
          @if (workflowForm.get('workflowTemplateId')?.hasError('required')) {
            <mat-error>
              {{'workTask.workflow_required' | translate}}
            </mat-error>
          }
        </mat-form-field>
      }

      @if (workflows && workflows.length === 0) {
        <div class="text-muted mt-3">
          {{'workflow.empty_workflow_templates' | translate}}
        </div>
      }

      <div class="form-control d-flex justify-content-between align-items-center p-3 mt-3">
        {{'workTask.workflow_synchronous' | translate}}
        <mat-slide-toggle formControlName="synchronous"></mat-slide-toggle>
      </div>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="onCancel();">{{'cancel' | translate}}</button>
  <button mat-button class="orange-button" (click)="onSave();" [disabled]="workflowForm.invalid">{{'apply' | translate}}</button>
</mat-dialog-actions>
